// extracted by mini-css-extract-plugin
module.exports = {"paper":"style-module_paper__2QUEQFe4AIPH-wbpNAx7Pr"};